export default __webpack_public_path__ + "static/media/art-1-main-sm.e817ec9c.jpg";